import { useMemo } from 'react'
import Button from '@components/Button'

const BUTTON_TYPES = {
    call: 'call_button',
    info: 'car_park_info',
    custom: 'custom',
    unassigned: 'null',
}

function UnbookableButton({ unbookableBtnType, unbookableBtnUrl, carParkUrl, phone }) {
    const getButtonProps = () => {
        switch (unbookableBtnType) {
            case BUTTON_TYPES.call:
                return {
                    href: `tel:${phone}`,
                    external: true,
                    children: (
                        <>
                            <T>unbookable.carpark.button.label.call</T>
                            {phone && <span className="text-small">{phone}</span>}
                        </>
                    ),
                }
            case BUTTON_TYPES.info:
                return {
                    href: carParkUrl,
                    target: '_blank',
                    external: true,
                    children: <T>unbookable.carpark.button.label.car.park.info</T>,
                }
            case BUTTON_TYPES.custom:
                return {
                    href: unbookableBtnUrl,
                    target: '_blank',
                    external: true,
                    children: <T>unbookable.carpark.button.label.custom</T>,
                }
        }
    }

    const props = useMemo(() => getButtonProps(), [unbookableBtnUrl, carParkUrl, unbookableBtnType, phone])

    return <Button btnStyle="outline" size="large" block {...props}></Button>
}

export { UnbookableButton, BUTTON_TYPES }
